<template>
    <div>
        <modal :show.sync="addItem" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar ítem</h6>
                <div class="form-group">
                    <label>Ítem *</label>
                    <fg-input   tabindex="0"
                                type="text"
                                name="item"
                                placeholder="item"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('item')"
                                v-model="itemName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Precio de compra</label>
                    <vue-numeric  :max=999999999999999 tabindex="1" currency="$" autocomplete="off" name="precio de compra" v-validate="modelValidations.sales" :error="getError('precio de compra')" separator="." class="form-control" v-model="itemPurchasePrice"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Precio de venta</label>
                    <vue-numeric  :max=999999999999999 tabindex="2" currency="$" autocomplete="off" name="precio de venta" v-validate="modelValidations.sales" :error="getError('precio de venta')" separator="." class="form-control" v-model="itemSalePrice"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>%</label>
                    <fg-input   type="number"
                                name="%"
                                disabled
                                placeholder="%"
                                autocomplete="off"
                                v-validate="modelValidations.sales"
                                :value="item_percent_computed"
                                :error="getError('%')"
                                v-model="itemPercent">
                    </fg-input>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddItem()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addItemToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <card class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Agregar línea de producto</h6>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label>Línea de productos *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="linea de productos"
                                placeholder="linea de productos"
                                autocomplete="off"
                                v-validate="modelValidations.product_name"
                                :error="getError('linea de productos')"
                                v-model="productLineName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>% Participación Ventas</label>
                    <fg-input   tabindex="2"
                                type="number"
                                name="% participacion ventas"
                                placeholder="% participacion ventas"
                                autocomplete="off"
                                v-validate="modelValidations.monthly"
                                :error="getError('% participacion ventas')"
                                v-model="productLinePercent">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Ventas por línea</label>
                    <vue-numeric  disabled :max=999999999999999 tabindex="3" currency="$" autocomplete="off" name="valor promedio de compra al mes" v-validate="modelValidations.sales" :error="getError('valor promedio de compra al mes')" separator="." class="form-control" v-model="productLineSalesComputed"></vue-numeric>
                </div>
                <!-- <div class="form-group">
                    <label>Total</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="total" disabled v-validate="modelValidations.sales" :error="getError('total')" separator="." class="form-control" v-model="productLineTotal"></vue-numeric>
                </div> -->
                <div v-if="productLineTotal != 0" class="alert alert-warning mt-2">
                    <span>Total: {{ setFormat(productLineTotal)}}</span>
                </div>
                <!-- <collapse v-for="item in items" :key="item.itemName">
                    <collapse-item :title="item.itemName+' - '+ item.itemPercent + '%'" :name="item.itemName">
                    <div>
                        Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                    </div>
                    </collapse-item>
                </collapse> -->
                <!-- <div v-if="items.length < 5">
                    <p-button 
                        @click="addItemMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar ítem
                    </p-button>
                </div>
                <div v-if="items.length > 1">
                    <p-button 
                        @click="removeItem()"
                        type="default" >
                        <i class="mr-2 fa fa-minus"></i>Quitar ítem
                    </p-button>
                </div> -->
                <div v-if=" (salesMonthlyAverage > 0)" class="alert alert-warning mt-2">
                    <span>Promedio ventas mensual: {{ salesMonthlyAverage}}%</span>
                </div>
                <div v-if=" (salesMonthlyAverage > 0)" class="alert alert-warning mt-2">
                    <span>Costo mensual de la línea: {{ setFormat(costsMonthlyLine)}}</span>
                </div>
            </div>
            <div class="card-footer">
                <div v-if="minimumSales != 0" class="alert alert-success">
                    <span>Ventas mensuales: {{ setFormat(minimumSales)}}</span>
                </div>
            </div>
        </card>
        <div class="text-right">
            <p-button v-if="productLineSalesComputed != 0 && productLineName != null" @click="saveCosts()" type="warning">Siguiente</p-button>
            <p-button @click="toGeneralCosts()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    export default {
        components: {
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal
        },
        data() {
        return {
            form: {
                average_selection: '',
            },
            minimumSales: null,
            itemName: '',
            itemPurchasePrice: '',
            itemSalePrice: '',
            itemPercent: '',
            productLineName: null,
            productLinePercent: null,
            productLineSales: null,
            productLinePurchaseCost: '',
            productLinePurchaseCostFormat: '',
            productLineMonthly: '',
            productLineTotal: '',
            productLineTotalFormat: '',
            addItem: false,
            items: [
                
            ],
            modelValidations: {
                sales: {
                    required: false
                },
                item_name: {
                    required: false,
                    max: 20
                },
                product_name: {
                    required: true,
                    max: 20
                },
                average_selection: {
                    required: false
                },
                monthly: {
                    numeric: true,
                    max_value: 100,
                    min_value: 1
                }
            },
        }
        },
        watch: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productLinePurchaseCost: function (val) {
                if (val != 0) {
                    if (this.productLineMonthly != 0) {
                        this.productLineTotal = parseFloat(val) * parseFloat(this.productLineMonthly);
                        this.productLineTotalFormat = this.setFormat(this.productLineTotal);
                        this.productLinePurchaseCostFormat = this.setFormat(val);
                    }
                }
                else {
                    this.productLineTotal = 0;
                    this.productLineTotalFormat = 0;
                    this.productLinePurchaseCostFormat = 0;

                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productLineMonthly: function (val) {
                if (val != 0) {
                    if (this.productLinePurchaseCost != 0) {
                        this.productLineTotal = parseFloat(val) * parseFloat(this.productLinePurchaseCost)
                    }
                }
                else {
                    this.productLineTotal = 0;
                }
            }
            
        },
        computed: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productLineSalesComputed () {
                // Calcula el valor multiplicando el porcentaje dividido por 100 y el mínimo de ventas
                const calculatedValue = (this.productLinePercent / 100) * this.minimumSales;
                // Asigna el valor calculado a productLineSales
                this.productLineSales = calculatedValue;
                // Retorna el valor calculado
                return calculatedValue;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            costsMonthlyLine () {
                return 5000;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            salesMonthlyAverage () {
                var avg = 0;
                var sum = 0;
                for (var i=0;i<this.items.length;i++) {
                    sum = sum + this.items[i].itemPercent;
                }
                avg = sum / this.items.length;
                return Math.round(avg);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            validateGeneralCosts () {
                if(this.productLineName && this.productLinePurchaseCost != 0 && this.productLineMonthly && (this.items.length >= 3 && this.items.length <= 5)) {
                    return true
                }
                else {
                    return false
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            item_percent_computed () {
                var percent = 0;
                if (this.itemPurchasePrice != 0 && this.itemSalePrice != 0) {
                    percent =  Math.round((this.itemPurchasePrice * 100) / this.itemSalePrice);
                }
                this.itemPercent = percent;
                return percent;
            },
        },
        methods: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addItemToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.itemName == '' || this.itemPercent == 0) {
                            this.showNotificationError('El campo nombre de ítem y porcentaje no pueden estar vacíos');
                        }
                        else {
                            this.items.push({
                                itemName: this.itemName,
                                itemPurchasePrice: this.itemPurchasePrice,
                                itemSalePrice: this.itemSalePrice,
                                itemPercent: this.itemPercent
                            })
                            this.resetItem();
                            this.addItem = false;
                            this.showNotificationSuccess('Producto agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeItem () {
                this.items.splice(this.items.length-1,1);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetItem () {
                this.itemName= '',
                this.itemPurchasePrice= '',
                this.itemSalePrice= '',
                this.itemPercent= ''
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addItemMethod () {
                this.addItem = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddItem () {
                this.addItem = false;
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            dailySelectValidation () {
                if (this.checkboxes.filter(day => day.value == true).length) {
                    return false
                }
                else {
                    return true
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            validateSwitch () {
                if(this.switches.daily || this.switches.weekly || this.switches.monthly || this.switches.product || this.switches.average) {
                    return true
                }
                else {
                    return false
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toGeneralCosts () {
                this.$router.push('/asessments/new_asessment/customer/costs/production/pyme/item');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            saveCosts () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        this.$store.dispatch('setPymeCostsProductLine', this.$data).then(()=>{
                            this.$store.dispatch('setCostsDataPopulate', true).then(()=>{
                                this.$router.push('/asessments/new_asessment/customer/costs/production/pyme/item');
                            });
                        });
                    }
                })
            }
        },
        mounted () {
            if (this.$store.state.isCustomer) {
                if (this.$store.state.isCustomer && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales != 0) {
                    this.minimumSales = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales;
                }
            }
            else if(this.$store.state.isSpouse) {
                if (this.$store.state.isSpouse && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales != 0) {
                    this.minimumSales = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales;
                }
            }
            else if (this.$store.state.isGuarantor) {
                if (this.$store.state.isGuarantor && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales != 0) {
                    this.minimumSales = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales;
                }
            }

        }
    }
</script>
<style>
</style>
